import React from 'react';
import HeaderToggle from './HeaderToggle';
import HeaderLogInOut from './HeaderLogInOut';
import HeaderNavItems from './HeaderNavItems';
import SkiftLogo from '../images/SkiftLogo';

const DesktopHeader = ({ setIsOpen, isOpen }) => (
    <section className='h-70px flex items-center justify-between mx-auto'>
        <div className='flex'>
            <a href='https://research.skift.com'>
                {/* Wider than the outgoing w-20 lockup: dropping RESEARCH
                    leaves a much squatter box, so the wordmark needs the extra
                    width to hold the same cap height in the 70px bar. */}
                <SkiftLogo className='h-auto w-24' />
            </a>
        </div>
        <nav className='w-full max-w-3xl mx-2.5 hidden wide:landscape:hidden sm:flex justify-around items-center gap-5'>
            <HeaderNavItems />
        </nav>
        <div className='hidden wide:landscape:hidden sm:block'>
            <HeaderLogInOut />
        </div>
        <HeaderToggle setIsOpen={setIsOpen} isOpen={isOpen} />
    </section>
);

export default DesktopHeader;
